// src/pages/AyarlarPage.js
import React, { useState, useMemo, useEffect } from "react";
import ResimUpload from "../ResimUpload";
import { API_BASE, UPLOAD_BASE, ORIGIN_BASE } from "../config";

/* --- UI DİLİ SÖZLÜĞÜ --- */
const t = {
  tr: { settings:"Ayarlar", uiLanguage:"Arayüz Dili", contentLanguage:"İçerik Dilleri",
    firmName:"Kurum / Firma Adı", slogan:"Slogan", branch:"Mahalle / Şube Adı",
    authorized:"Yetkili Adı", authorizedEditable:"Yetkili Adı (Düzenle)", city:"İl", district:"İlçe",
    phone:"Telefon", email:"E-Posta", website:"Web Sitesi", logoUpload:"Logo Yükle",
    theme:"Tema", light:"Açık Tema", dark:"Koyu Tema", social:"Sosyal Medya",
    facebook:"Facebook", instagram:"Instagram", twitter:"Twitter (X)", linkedin:"LinkedIn",
 menuManager: "🛠️ Menü Yönetimi",
    addCategory: "➕ Kategori Ekle",
    categoryPlaceholder: "Kategori adı (Örn: Çorbalar)",
    productImage: "Ürün Görseli",
    productName: "Ürün adı",
    productDesc: "Ürün açıklaması",
    price: "Fiyat",
    addProduct: "➕ Ürün / Hizmet Ekle",
    edit: "Düzenle",
    saveInline: "💾 Kaydet",
    delete: "Sil",
    productCount: "ürün",
currencyTRY: "₺ TRY",
currencyUSD: "$ USD",
currencyEUR: "€ EUR",
currencyCHF: "CHF",
allergens: {
  gluten: "Gluten",
  lactose: "Laktoz",
  peanut: "Fıstık",
  egg: "Yumurta",
  soy: "Soya",

},
passwordChangeTitle: "🔐 Şifre Değiştir",
passwordChangeDesc: "Mevcut şifrenizi girerek yeni şifre belirleyin",
currentPassword: "Mevcut şifre",
newPassword: "Yeni şifre",
newPasswordRepeat: "Yeni şifre (tekrar)",
updatePassword: "Şifreyi Güncelle",
passwordUpdated: "✅ Şifre başarıyla güncellendi",
fillAllFields: "Lütfen tüm alanları doldurun",
passwordsNotMatch: "Yeni şifreler uyuşmuyor",
passwordMin: "Yeni şifre en az 6 karakter olmalı",
sessionNotFound: "Oturum bulunamadı",
passwordUpdateFail: "Şifre değiştirilemedi",
downloadsTitle: "Dosya & Link Paylaşımları",
downloadAdd: "Yeni Dosya / Link Ekle",
downloadEdit: "Dosya / Link Güncelle",
uploadFile: "Dosya Yükle",
noDownloads: "Henüz eklenmiş dosya / link yok.",
file: "Dosya",
title: "Başlık",
description: "Açıklama",
add: "Ekle",
update: "Güncelle",
unnamed: "Başlıksız",
link: "Link",
menuLangTitle: "🌍 Menü Dil Seçimi",
menuLangDesc: "Menü web sayfasında hangi dillerde görünsün?",
trendProduct: "⭐ Trend Ürün",


categorySelect: "Kategori seç",
marketplaceVisibility: "Kurum Kullanıcı Görünürlüğü",
marketplaceVisibilityDesc: "Kullanıcılar hangi kurumları görebilsin?",
marketplaceAll: "Tüm kurumlar",
marketplaceOwnSector: "Kendi sektörüm Dışındakiler",
marketplaceNone: "Hiçbir kurumu gösterme",




    youtube:"YouTube", save:"Kaydet", success:"✅ Ayarlar Kaydedildi", fail:"❌ Kayıt başarısız oldu.",

menuSettings: "Menü / Hizmet Ayarları",

  menuEnableTitle: "Menü / Fiyat Listesi",
    menuEnableDesc: "Kafe, restoran, yol yardımı, hizmet listesi vb.",
    allergenTitle: "Alerji Bilgileri",
    allergenDesc: "Gluten, laktoz, fıstık vb.",
    serverError:"❌ Sunucu hatası." },
  en: { settings:"Settings", uiLanguage:"UI Language", contentLanguage:"Content Languages",
    firmName:"Organization / Company Name", slogan:"Slogan", branch:"Neighborhood / Branch Name",
    authorized:"Authorized Person", authorizedEditable:"Authorized (Editable)", city:"City", district:"District",
    phone:"Phone", email:"Email", website:"Website", logoUpload:"Upload Logo",
    theme:"Theme", light:"Light Theme", dark:"Dark Theme", social:"Social Media",
    facebook:"Facebook", instagram:"Instagram", twitter:"Twitter (X)", linkedin:"LinkedIn",
  menuManager: "🛠️ Menu Management",
    addCategory: "➕ Add Category",
    categoryPlaceholder: "Category name (e.g. Soups)",
    productImage: "Product Image",
    productName: "Product name",
    productDesc: "Product description",
    price: "Price",
    addProduct: "➕ Add Product / Service",
    edit: " Edit",
    saveInline: "💾 Save",
    delete: "Delete",
    productCount: "items",
downloadsTitle: "Files & Links",
downloadAdd: "Add File / Link",
downloadEdit: "Edit File / Link",
uploadFile: "Upload File",
noDownloads: "No files or links added yet.",
file: "File",
link: "Link",
title: "Title",
description: "Description",
add: "Add",
update: "Update",
unnamed: "Untitled",
categorySelect: "Select category",



currencyTRY: "₺ TRY",
currencyUSD: "$ USD",
currencyEUR: "€ EUR",
currencyCHF: "CHF",
allergens: {
  gluten: "Gluten",
  lactose: "Lactose",
  peanut: "Peanuts",
  egg: "Egg",
  soy: "Soy",
},
passwordChangeTitle: "🔐 Change Password",
passwordChangeDesc: "Set a new password by entering your current password",
currentPassword: "Current password",
newPassword: "New password",
newPasswordRepeat: "New password (repeat)",
updatePassword: "Update Password",
passwordUpdated: "✅ Password updated successfully",
fillAllFields: "Please fill in all fields",
passwordsNotMatch: "Passwords do not match",
passwordMin: "Password must be at least 6 characters",
sessionNotFound: "Session not found",
passwordUpdateFail: "Password could not be updated",
menuLangTitle: "🌍 Menu Language Selection",
menuLangDesc: "In which languages should the menu appear on the website?",
 youtube:"YouTube", save:"Save", success:"✅ Settings Saved", fail:"❌ Save failed.",
trendProduct: "⭐ Trending Product",
marketplaceVisibility: "Marketplace Visibility",
marketplaceVisibilityDesc: "Which institutions can users see?",
marketplaceAll: "All institutions",
marketplaceOwnSector: "Other sectors",
marketplaceNone: "Show no institutions",



  menuSettings: "Menu / Service Settings",
    menuEnableTitle: "Menu / Price List",
    menuEnableDesc: "Cafe, restaurant, service list, etc.",
    allergenTitle: "Allergen Information",
    allergenDesc: "Gluten, lactose, peanuts, etc.",
    serverError:"❌ Server error." },




  de: { settings:"Einstellungen", uiLanguage:"UI-Sprache", contentLanguage:"Inhaltssprachen",
    firmName:"Organisation / Firmenname", slogan:"Slogan", branch:"Stadtteil / Filiale",
    authorized:"Verantwortliche Person", authorizedEditable:"Verantwortliche (bearbeitbar)",
    city:"Stadt", district:"Bezirk", phone:"Telefon", email:"E-Mail", website:"Webseite",
    logoUpload:"Logo hochladen", theme:"Theme", light:"Helles Theme", dark:"Dunkles Theme",
    social:"Soziale Medien", facebook:"Facebook", instagram:"Instagram", twitter:"Twitter (X)",
    linkedin:"LinkedIn", youtube:"YouTube", save:"Speichern", success:"✅ Einstellungen Gespeichert",
   menuManager: "🛠️ Menüverwaltung",
    addCategory: "➕ Kategorie hinzufügen",
    categoryPlaceholder: "Kategoriename (z. B. Suppen)",
    productImage: "Produktbild",
    productName: "Produktname",
    productDesc: "Produktbeschreibung",
    price: "Preis",
    addProduct: "➕ Produkt / Dienst hinzufügen",
    edit: "Bearbeiten",
    saveInline: "💾 Speichern",
    delete: "Löschen",
    productCount: "Produkte",
downloadsTitle: "Dateien & Links",
downloadAdd: "Datei / Link hinzufügen",
downloadEdit: "Datei / Link bearbeiten",
uploadFile: "Datei hochladen",
noDownloads: "Noch keine Dateien oder Links vorhanden.",
file: "Datei",
link: "Link",
menuLangTitle: "🌍 Menü-Sprachauswahl",
menuLangDesc: "In welchen Sprachen soll das Menü auf der Website angezeigt werden?",



title: "Titel",
description: "Beschreibung",
add: "Hinzufügen",
update: "Aktualisieren",
unnamed: "Ohne Titel",
categorySelect: "Kategorie auswählen",
marketplaceVisibility: "Marktplatz-Sichtbarkeit",
marketplaceVisibilityDesc: "Welche Institutionen können Benutzer sehen?",
marketplaceAll: "Alle Institutionen",
marketplaceOwnSector: "Andere Branchen",
marketplaceNone: "Keine Institutionen anzeigen",


currencyTRY: "₺ TRY",
currencyUSD: "$ USD",
currencyEUR: "€ EUR",
currencyCHF: "CHF",
allergens: {
  gluten: "Gluten",
  lactose: "Laktose",
  peanut: "Erdnüsse",
  egg: "Ei",
  soy: "Soja",
},
passwordChangeTitle: "🔐 Passwort ändern",
passwordChangeDesc: "Legen Sie ein neues Passwort mit Ihrem aktuellen Passwort fest",
currentPassword: "Aktuelles Passwort",
newPassword: "Neues Passwort",
newPasswordRepeat: "Neues Passwort (wiederholen)",
updatePassword: "Passwort aktualisieren",
passwordUpdated: "✅ Passwort erfolgreich aktualisiert",
fillAllFields: "Bitte alle Felder ausfüllen",
passwordsNotMatch: "Passwörter stimmen nicht überein",
passwordMin: "Passwort muss mindestens 6 Zeichen lang sein",
sessionNotFound: "Sitzung nicht gefunden",
passwordUpdateFail: "Passwort konnte nicht geändert werden",

    menuSettings: "Menü- / Serviceeinstellungen",
    menuEnableTitle: "Menü / Preisliste",
    menuEnableDesc: "Café, Restaurant, Serviceliste usw.",
    allergenTitle: "Allergeninformationen",
    allergenDesc: "Gluten, Laktose, Erdnüsse usw.",
trendProduct: "⭐ Trendprodukt",


    fail:"❌ Speichern fehlgeschlagen.", serverError:"❌ Serverfehler." },



};
/* ✅ ALLERGEN SABİTLERİ — BURAYA */
const ALLERGEN_KEYS = ["gluten", "lactose", "peanut", "egg", "soy"];


const LANGS = [
  { code: "tr", label: "TR" },
  { code: "en", label: "EN" },
  { code: "de", label: "DE" },
];

/* 🔒 SABİT ANA KATEGORİLER – TR / EN / DE */
const CATEGORY_DICT = {
  main_dishes: {
    tr: "Ana Yemekler",
    en: "Main Dishes",
    de: "Hauptgerichte",
  },

  grill: {
    tr: "Izgara Çeşitleri",
    en: "Grilled Dishes",
    de: "Grillgerichte",
  },


doner_kebab: {
  tr: "Döner & Kebap",
  en: "Doner & Kebab",
  de: "Döner & Kebab",
},


  fish: {
    tr: "Balık Çeşitleri",
    en: "Fish Dishes",
    de: "Fischgerichte",
  },




pizza_pasta: {
  tr: "Pizza",
  en: "Pizza",
  de: "Pizza",
},

pasta: {
  tr: "Makarna",
  en: "Pasta",
  de: "Pasta",
},

durum: {
  tr: "Dürüm",
  en: "Wrap",
  de: "Dürüm",
},

  home_food: {
    tr: "Ev Yemekleri",
    en: "Home Style Dishes",
    de: "Hausgemachte Gerichte",
  },

  fast_food: {
    tr: "Fast Food",
    en: "Fast Food",
    de: "Fast Food",
  },


  world_cuisine: {
    tr: "Dünya Mutfağı",
    en: "World Cuisine",
    de: "Internationale Küche",
  },

 chef_special: {
    tr: "Şefin Spesiyali",
    en: "Chef’s Special",
    de: "Empfehlung des Küchenchefs",
  },

  local_food: {
    tr: "Yöresel Lezzetler",
    en: "Local Specialties",
    de: "Regionale Spezialitäten",
  },

 
  vegetarian: {
    tr: "Vejetaryen / Vegan",
    en: "Vegetarian / Vegan",
    de: "Vegetarisch / Vegan",
  },


  gluten_free: {
    tr: "Gluten-Free Seçenekler",
    en: "Gluten-Free Options",
    de: "Glutenfreie Optionen",
  },

 smoothies: {
    tr: "Smoothie & Sağlıklı İçecekler",
    en: "Smoothies & Healthy Drinks",
    de: "Smoothies & Gesunde Getränke",
  },

mezze: {
  tr: "Meze",
  en: "Appetizers",
  de: "Vorspeisen",
},

 sides: {
    tr: "Garnitürler",
    en: "Side Dishes",
    de: "Beilagen",
  },



  soups: {
    tr: "Çorbalar",
    en: "Soups",
    de: "Suppen",
  },

  salads: {
    tr: "Salatalar",
    en: "Salads",
    de: "Salate",
  },


  breakfast: {
    tr: "Kahvaltı",
    en: "Breakfast",
    de: "Frühstück",
  },



 ice_cream: {
  tr: "Dondurmalar",
  en: "Ice Cream",
  de: "Eis",
},

  coffee: {
    tr: "Kahveler",
    en: "Coffee",
    de: "Kaffee",
  },


  hot_drinks: {
    tr: "Sıcak İçecekler",
    en: "Hot Drinks",
    de: "Heiße Getränke",
  },


  cold_drinks: {
    tr: "Soğuk İçecekler",
    en: "Cold Drinks",
    de: "Kalte Getränke",
  },




  alcohol: {
    tr: "Alkollü İçecekler",
    en: "Alcoholic Beverages",
    de: "Alkoholische Getränke",
  },

 


  kids_menu: {
    tr: "Çocuk Menüsü",
    en: "Kids Menu",
    de: "Kindermenü",
  },


  bakery: {
    tr: "Unlu Mamüller",
    en: "Bakery Products",
    de: "Backwaren",
  },

 pastry: {
    tr: "Börek ve Poğaça",
    en: "Pastries",
    de: "Börek & Gebäck",
  },

  desserts: {
    tr: "Tatlılar",
    en: "Desserts",
    de: "Desserts",
  },


hookah: {
  tr: "Nargile",
  en: "Hookah",
  de: "Shisha",
},

 
};



/* ---- AKSENT RENGİ ---- */
const ACCENT = "orange";
const clsActive = () => (ACCENT === "orange" ? "bg-orange-600 text-white" : "bg-blue-600 text-white");
const clsInactive = () => (ACCENT === "orange" ? "bg-white text-orange-700 border-orange-600 hover:bg-orange-50" : "bg-white text-blue-700 border-blue-600 hover:bg-blue-50");

const Segmented = ({ value, onChange }) => (
  <div className="inline-flex rounded-2xl border bg-white shadow-sm overflow-hidden">
    {LANGS.map((l, idx) => {
      const active = value === l.code;
      return (
        <button
          key={l.code}
          type="button"
          onClick={() => onChange(l.code)}
          className={[
            "px-4 py-2 text-base font-semibold transition border",
            active ? clsActive() : clsInactive(),
            idx !== LANGS.length - 1 ? "border-r-0" : "",
          ].join(" ")}
        >
          {l.label}
        </button>
      );
    })}
  </div>
);

/* ===========================================================
   Upload URL normalize (panel → ana domain, http→https, /uploads…)
   =========================================================== */
const ORIGIN = ORIGIN_BASE || (typeof window !== "undefined" ? window.location.origin : "");
const UP_BASE = (UPLOAD_BASE && UPLOAD_BASE.trim()) || "";

// panel.haymestasarim.com → haymestasarim.com
function originWithoutPanel(originStr) {
  try {
    const u = new URL(originStr);
    if (u.hostname.startsWith("panel.")) {
      u.hostname = u.hostname.replace(/^panel\./, "");
      return u.origin;
    }
    return u.origin;
  } catch {
    return originStr;
  }
}

function normalizeUploadUrl(raw) {
  if (!raw) return "";
  let u = String(raw).trim();
  u = u.replace(/^http:\/\//i, "https://");
  if (!/^https?:\/\//i.test(u) && !u.startsWith("/")) {
    u = `/uploads/${u}`;
  }
  const strip = (p) => p.replace(/^\/?(upload|uploads)\//i, "").replace(/^\/+/, "");
  try {
    const abs = new URL(u, ORIGIN);
    const filePart = strip(abs.pathname);
    const chosenOrigin = UP_BASE ? new URL(UP_BASE, ORIGIN).origin : originWithoutPanel(ORIGIN);
    const baseUrl = new URL(UP_BASE || "/uploads", chosenOrigin);
    let basePath = baseUrl.pathname.replace(/\/+$/, "");
    if (!/(\/upload(s)?)$/i.test(basePath)) basePath += "/uploads";
    return `${baseUrl.origin}${basePath}/${filePart}`;
  } catch {
    return u;
  }
}

/* ===========================================================
   Endpoint keşfi (GET) + düz POST ile kaydetme (Duyurular'la aynı mantık)
   =========================================================== */
const SETTINGS_CANDIDATES = [
  "kurum-ayarlar",
  "kurum-ayar",
  "ayarlar",
  "settings",
];

async function apiGetSettings(token) {
  const order = [localStorage.getItem("app_settings_ep")]
    .filter(Boolean)
    .concat(SETTINGS_CANDIDATES);

  for (const ep of order) {
    try {
      const res = await fetch(`${API_BASE}/${ep}`, {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.ok) {
        localStorage.setItem("app_settings_ep", ep);
        return { ep, res };
      }
    } catch (e) {
      // sessiz geç
    }
  }

  // 🔁 fallback
  const ep = SETTINGS_CANDIDATES[0];
  const res = await fetch(`${API_BASE}/${ep}`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  return { ep, res };
}

// DÜZ POST JSON — 404 gelirse bir sonrakini dener
async function saveSettingsJson(token, body) {
  const eps = [localStorage.getItem("app_settings_ep")]
    .filter(Boolean)
    .concat(SETTINGS_CANDIDATES);

  for (const ep of eps) {
    try {
      const res = await fetch(`${API_BASE}/${ep}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      });

      if (res.ok) {
        localStorage.setItem("app_settings_ep", ep);
        return res;
      }
      if (res.status === 404) continue;
    } catch (e) {
      // sessiz geç
    }
  }

  return fetch(`${API_BASE}/${SETTINGS_CANDIDATES[0]}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });
}

// ================= MENU BACKEND KAYIT =================
async function saveMenuToBackend(menuCategories) {
  const token = localStorage.getItem("token");
  if (!token) return;
// 🔥 MENÜ DİLLERİ – GERÇEK OTORİTE
const activeMenuLangs =
  JSON.parse(localStorage.getItem("menu_langs")) || ["tr"];


  // 1️⃣ Eski menüyü sil (reset)
  const secRes = await fetch(`${API_BASE}/extra-sections`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const secs = await secRes.json();

  for (const s of secs.data || []) {
    await fetch(`${API_BASE}/extra-sections/${s.id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` }
    });
  }

  // 2️⃣ Yeniden kaydet
  for (let sira = 0; sira < menuCategories.length; sira++) {
    const cat = menuCategories[sira];
    const label = CATEGORY_DICT[cat.key] || {};

    // === SECTION ===
    const sec = await fetch(`${API_BASE}/extra-sections`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({
        category_key: cat.key,
    title_tr: activeMenuLangs.includes("tr") ? (label.tr || "") : "",
title_en: activeMenuLangs.includes("en") ? (label.en || "") : "",
title_de: activeMenuLangs.includes("de") ? (label.de || "") : "",

        aktif: true,
        sira
      })
    }).then(r => r.json());

 // === CATEGORY ===
const category = await fetch(`${API_BASE}/extra-categories`, {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`
  },
  body: JSON.stringify({
    section_id: sec.data.id,
    title_tr: activeMenuLangs.includes("tr") ? (label.tr || "") : "",
    title_en: activeMenuLangs.includes("en") ? (label.en || "") : "",
    title_de: activeMenuLangs.includes("de") ? (label.de || "") : "",
    aktif: true,
    sira: 0
  })
}).then(r => r.json());


    // === ITEMS ===
    for (let i = 0; i < cat.items.length; i++) {
      const item = cat.items[i];

      await fetch(`${API_BASE}/extra-items`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          category_id: category.data.id,
     title_tr: activeMenuLangs.includes("tr") ? item.name : "",
title_en: activeMenuLangs.includes("en") ? item.name : "",
title_de: activeMenuLangs.includes("de") ? item.name : "",

description_tr: activeMenuLangs.includes("tr") ? item.description : "",
description_en: activeMenuLangs.includes("en") ? item.description : "",
description_de: activeMenuLangs.includes("de") ? item.description : "",

          price: item.price,
          currency: item.currency,
          image: item.image,
          allergens: JSON.stringify(item.allergens || []),
 // ⭐ EKLENDİ
  is_trend: item.is_trend === true,
          aktif: true,
          sira: i
        })
      });
    }
  }
}





/* ============================== SAYFA ============================== */
export default function AyarlarPage() {

// ================= DOSYA & LINK PAYLAŞIMLARI =================
const [downloads, setDownloads] = useState([]);


const [downloadDraft, setDownloadDraft] = useState({
  title: { tr:"", en:"", de:"" },
  description: { tr:"", en:"", de:"" },
  file: "",
  link: ""
});


const [editingDownloadId, setEditingDownloadId] = useState(null);



// 👇 KATEGORİ AKORDİYON STATE
const [openCategoryId, setOpenCategoryId] = useState(null);

// 🔐 ŞİFRE DEĞİŞTİR STATE
const [openPass, setOpenPass] = useState(false);
const [currentPassword, setCurrentPassword] = useState("");
const [newPassword, setNewPassword] = useState("");
const [newPassword2, setNewPassword2] = useState("");
const [passLoading, setPassLoading] = useState(false);

// 🔁 KATEGORİ SÜRÜKLE – BIRAK SIRALAMA
const moveCategory = (fromIndex, toIndex) => {
  if (fromIndex === toIndex) return;

  setMenuCategories(prev => {
    const copy = [...prev];
    const [moved] = copy.splice(fromIndex, 1);
    copy.splice(toIndex, 0, moved);
    return copy;
  });
};
// ================= RANDEVU SİSTEMİ =================
const [enableBooking, setEnableBooking] = useState(false);

// ================= PAZAR YERİ GÖRÜNÜRLÜK =================
const [marketplaceVisibility, setMarketplaceVisibility] = useState("all"); // "all", "sector", "none"

// ================= MUHASEBE / VERGİ / SİGORTA =================
const [enableAccounting, setEnableAccounting] = useState(false);

// ================= DİJİTAL İMZA SİSTEMİ =================
const [enableDigitalSignature, setEnableDigitalSignature] = useState(false);


// === MENÜ YÖNETİMİ STATE ===

const [menuCategories, setMenuCategories] = useState([]);

const loadMenuFromBackend = async () => {
  const token = localStorage.getItem("token");
  if (!token) return;

  // 1️⃣ Sections
  const secRes = await fetch(`${API_BASE}/extra-sections`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const secJson = await secRes.json();

 // 🔹 Tüm kategorileri TEK SEFER çek
const allCatRes = await fetch(`${API_BASE}/extra-categories`, {
  headers: { Authorization: `Bearer ${token}` }
});
const allCatJson = await allCatRes.json();

// 🔹 Tüm ürünleri TEK SEFER çek
const allItemRes = await fetch(`${API_BASE}/extra-items`, {
  headers: { Authorization: `Bearer ${token}` }
});
const allItemJson = await allItemRes.json();

const result = [];

for (const sec of secJson.data || []) {
  const cats = allCatJson.data.filter(c => c.section_id === sec.id);

  for (const cat of cats) {
const menuLangs =
  JSON.parse(localStorage.getItem("menu_langs")) || ["tr"];
const menuLang = menuLangs[0];


const items = allItemJson.data
  .filter(i => i.category_id === cat.id)
  .map(i => ({
    id: i.id,
    name:
      i[`title_${menuLang}`] ||
      i.title_tr ||
      "",
    description:
      i[`description_${menuLang}`] ||
      i.description_tr ||
      "",
    price: i.price,
    currency: i.currency,
    image: i.image,
    allergens: JSON.parse(i.allergens || "[]"),
 // ⭐ EKLENDİ
    is_trend: i.is_trend === true
  }));



    result.push({
  id: sec.id,
  key: sec.category_key,   // ✅ TEK DOĞRU
  name: sec.title_tr,      // fallback
  items,
  draft: {
    title: { tr: "", en: "", de: "" },
    description: { tr: "", en: "", de: "" },
    price: "",
    currency: "TRY",
    image: "",
    allergens: []
  }
});

  }
}

  setMenuCategories(result);
};






// Extra (Menü / Kafe vb.)
const [enableMenu, setEnableMenu] = useState(false);
const [enableAllergens, setEnableAllergens] = useState(false);
// 🌍 MENÜ YAYIN DİLLERİ (WEB İÇİN)
const [menuLangs, setMenuLangs] = useState(["tr"]);

const toggleMenuLang = (code) => {
  setMenuLangs(prev =>
    prev.includes(code) ? prev.filter(l => l !== code) : [...prev, code]
  );
};


  /* UI dili */
  const [uiLang, setUiLang] = useState(localStorage.getItem("app_lang") || localStorage.getItem("lang") || "tr");
  const TT = t[uiLang] || t.tr;

  /* Varsayılan içerik dili & aktif diller */
  const [contentLang, setContentLang] = useState("tr");
  const [activeContentLangs, setActiveContentLangs] = useState(["tr"]);
  const toggleActiveLang = (code) => setActiveContentLangs((prev) => (prev.includes(code) ? prev.filter((x) => x !== code) : [...prev, code]));

  /* Dil-özel metinler */
  const [firmaAdiByLang, setFirmaAdiByLang] = useState({ tr: "HayMes Tasarım", en: "", de: "" });
  const [sloganByLang, setSloganByLang] = useState({ tr: "", en: "", de: "" });

  /* Diğer alanlar */
  const [subeAdi, setSubeAdi] = useState("");
  const [telefon, setTelefon] = useState("");
  const [email, setEmail] = useState("");
  const [website, setWebsite] = useState("");
  const [il, setIl] = useState("");
  const [ilce, setIlce] = useState("");
  const [facebook, setFacebook] = useState("");
  const [instagram, setInstagram] = useState("");
  const [twitter, setTwitter] = useState("");
  const [linkedin, setLinkedin] = useState("");
  const [youtube, setYoutube] = useState("");
  const [tema, setTema] = useState("light");

  /* === LOGO (Etkinlikler ile aynı: URL string) === */
  const [logo, setLogo] = useState("");
  const [logoVer, setLogoVer] = useState(0);
  const buildLogoPreview = (u) => {
    const fixed = normalizeUploadUrl(u || "");
    if (!fixed) return "";
    const abs = fixed.startsWith("http") ? fixed : new URL(fixed, originWithoutPanel(ORIGIN)).href;
    return `${abs}${abs.includes("?") ? "&" : "?"}v=${logoVer}`;
  };
  const previewUrl = logo ? buildLogoPreview(logo) : "";

  const [isSaving, setIsSaving] = useState(false);
  const [newAuthorized, setNewAuthorized] = useState("");

  const defaultLangOptions = useMemo(() => LANGS.filter((l) => activeContentLangs.includes(l.code)), [activeContentLangs]);

  /* Ayarları oku */
  const loadSettings = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) return;

      const { res } = await apiGetSettings(token);
      if (!res.ok) return;

      const json = await res.json();
      const d = json?.data;
      if (!d) return;

if (Array.isArray(d.aktif_diller) && d.aktif_diller.length > 0) {
  setActiveContentLangs(d.aktif_diller);

  // 🔥 contentLang AKTİF DİLLERE GÖRE BELİRLENİR
  if (d.dil && d.aktif_diller.includes(d.dil)) {
    setContentLang(d.dil);
  } else {
    setContentLang("tr");
  }
} else {
  setActiveContentLangs(["tr"]);
  setContentLang("tr");
}


      setFirmaAdiByLang({ tr: d.firma_adi_tr || "", en: d.firma_adi_en || "", de: d.firma_adi_de || "" });
      setSloganByLang({ tr: d.slogan_tr || "", en: d.slogan_en || "", de: d.slogan_de || "" });

      setSubeAdi(d.sube_adi || "");
      setNewAuthorized(d.yetkili_adi || "");
      setIl(d.il || "");
      setIlce(d.ilce || "");
      setTelefon(d.telefon || "");
      setEmail(d.email || "");
      setWebsite(d.website || "");
      setFacebook(d.facebook || "");
      setInstagram(d.instagram || "");
      setTwitter(d.twitter || "");
      setLinkedin(d.linkedin || "");
      setYoutube(d.youtube || "");
      setTema(d.tema || "light");
setEnableMenu(
  d.menu_enabled === true || d.menu_enabled === "true"
);

setEnableAllergens(
  d.allergen_enabled === true || d.allergen_enabled === "true"
);


// 🌍 Menü yayın dilleri (menu_langs)
if (Array.isArray(d.menu_langs) && d.menu_langs.length) {
  setMenuLangs(d.menu_langs);
} else {
  setMenuLangs(["tr"]);
}


      setLogo(normalizeUploadUrl(d.logo_url || d.logo || ""));
      setLogoVer((n) => n + 1);

// 📎 DOSYA & LINK PAYLAŞIMLARI
if (Array.isArray(d.downloads)) {
  setDownloads(d.downloads);
} else {

  setDownloads([]);
}

// 🔥 MUHASEBE AYARINI AYRI ENDPOINT'TEN ÇEK
try {
  const accRes = await fetch(`${API_BASE}/accounting/settings`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (accRes.ok) {
    const accJson = await accRes.json();
    setEnableAccounting(
      accJson?.data?.accounting_aktif === true
    );
  }
} catch (e) {
  console.error("Muhasebe ayarı okunamadı", e);
}

// 🔥 DİJİTAL İMZA AYARINI AYRI ENDPOINT'TEN ÇEK
try {
  const signatureRes = await fetch(`${API_BASE}/dijitalimza/settings`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (signatureRes.ok) {
    const signatureJson = await signatureRes.json();
    setEnableDigitalSignature(
      signatureJson?.data?.dijital_imza_aktif === true
    );
  }
} catch (e) {
  console.error("Dijital imza ayarı okunamadı", e);
}



// 🔥 RANDEVU AYARINI AYRI ENDPOINT'TEN ÇEK
try {
  const bookingRes = await fetch(`${API_BASE}/randevu/settings`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (bookingRes.ok) {
    const bookingJson = await bookingRes.json();
    setEnableBooking(
      bookingJson?.data?.randevu_aktif === true
    );
  }
} catch (e) {
  console.error("Randevu ayarı okunamadı", e);
}

// Pazar yeri görünürlük
setMarketplaceVisibility(d.marketplace_visibility || "all");





    } catch (e) {
      console.error("GET settings hata:", e);
    }
  };

useEffect(() => {
  loadSettings();
  loadMenuFromBackend(); // 👈 BU KRİTİK
}, []);

  const handleSave = async () => {
localStorage.setItem("content_lang", contentLang);

  // 🔥 EKLENECEK TEK SATIR
  localStorage.setItem(
    "menu_langs",
    JSON.stringify(menuLangs.length ? menuLangs : ["tr"])
  );

    if (isSaving) return;
    setIsSaving(true);
    const token = localStorage.getItem("token");

    // UI dilini kalıcı yap
    localStorage.setItem("app_lang", uiLang);
    localStorage.setItem("lang", uiLang);
    window.dispatchEvent(new Event("app_lang_change"));

    // Çok dilliler – aktif olmayanlar boş string
    const multilanguagePayload = {};
    LANGS.forEach(({ code }) => {
      const active = activeContentLangs.includes(code);
      multilanguagePayload[`firma_adi_${code}`] = active ? (firmaAdiByLang[code] || "").trim() : "";
      multilanguagePayload[`slogan_${code}`] = active ? (sloganByLang[code] || "").trim() : "";
    });

    const normalizedLogo = normalizeUploadUrl(logo);


// 🧹 BOŞ DOSYA / LINK KARTLARINI TEMİZLE
const cleanedDownloads = downloads.filter(d =>
  d.file ||
  d.link ||
  d.title?.tr ||
  d.title?.en ||
  d.title?.de
);

    const body = {
      ...multilanguagePayload,
      aktif_diller: activeContentLangs.length ? activeContentLangs : ["tr"],
      dil: contentLang || "tr",
menu_langs: menuLangs.length ? menuLangs : ["tr"],


      sube_adi: subeAdi || "",
      yetkili_adi: newAuthorized || "",
      il: il || "",
      ilce: ilce || "",
      telefon: telefon || "",
      email: email || "",
      website: website || "",
      facebook: facebook || "",
      instagram: instagram || "",
      twitter: twitter || "",
      linkedin: linkedin || "",
      youtube: youtube || "",
      tema: tema || "light",
      // Duyurular/Etkinlikler formatına paralel: düz URL string
      logo: normalizedLogo,
      // uyumluluk için ikinci anahtar
      logo_url: normalizedLogo,
 menu_enabled: enableMenu,
  allergen_enabled: enableAllergens,

   // 📅 Randevu Sistemi
booking_enabled: enableBooking === true,

// 🧾 Muhasebe / Vergi / Sigorta
accounting_enabled: enableAccounting === true,

  marketplace_visibility: marketplaceVisibility,


  menu: menuCategories,
downloads: cleanedDownloads,
    };



    try {
      const res = await saveSettingsJson(token, body);

try { await res.clone().json(); } catch {}

// 🔥 MENÜ DİLLERİNİ AYRI ENDPOINT İLE KAYDET
await fetch(`${API_BASE}/kurum-ayarlar/menu-langs`, {
  method: "PUT",
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  },
  body: JSON.stringify({
    menu_langs: menuLangs.length ? menuLangs : ["tr"],
  }),
});

localStorage.setItem("app_institution_by_lang", JSON.stringify(firmaAdiByLang));



      localStorage.setItem("app_institution_name", firmaAdiByLang[uiLang] || firmaAdiByLang[contentLang] || firmaAdiByLang.tr || "");
      localStorage.setItem("app_authorized_name", newAuthorized || "");
      localStorage.setItem("app_logo_url", normalizedLogo || "/logo192.png");
      window.dispatchEvent(new Event("app_settings_change"));

alert(res.ok ? TT.success : TT.fail);

if (res.ok) {
  // 🔒 STATE SNAPSHOT (kritik)
  const snapshotMenu = JSON.parse(JSON.stringify(menuCategories));

  /* ============================
     📅 RANDEVU AYARINI KAYDET
     ============================ */
  try {
    await fetch(`${API_BASE}/randevu/settings`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        randevu_aktif: enableBooking === true,
      }),
    });

} catch (e) {
    console.error("Randevu ayarı kaydedilemedi", e);
  }

/* ============================
   🧾 MUHASEBE AYARINI KAYDET
   ============================ */
try {
  await fetch(`${API_BASE}/accounting/settings`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      accounting_aktif: enableAccounting === true,
    }),
  });
} catch (e) {
  console.error("Muhasebe ayarı kaydedilemedi", e);
}


/* ============================
   📄 DİJİTAL İMZA AYARINI KAYDET
   ============================ */
try {
  await fetch(`${API_BASE}/dijitalimza/settings`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      dijital_imza_aktif: enableDigitalSignature === true,
    }),
  });
  console.log("✅ Dijital imza ayarı kaydedildi");
} catch (e) {
  console.error("❌ Dijital imza ayarı kaydedilemedi", e);
}

/* ============================
   🏬 PAZAR YERİ GÖRÜNÜRLÜK AYARINI KAYDET
   ============================ */
try {
  await fetch(`${API_BASE}/market/visibility`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      visibility: marketplaceVisibility,
    }),
  });
  console.log("✅ Pazar yeri görünürlük kaydedildi:", marketplaceVisibility);
} catch (e) {
  console.error("❌ Pazar yeri görünürlük kaydedilemedi", e);
}

  await saveMenuToBackend(snapshotMenu);
  await loadMenuFromBackend(); // 👈 geri gelince dolu görünsün
  loadSettings();

  // 🔔 Sidebar / Menü anında güncellensin
  window.dispatchEvent(new Event("app_settings_change"));
}



} catch (err) {
  console.error(err);
  alert(TT.serverError);
} finally {
  setIsSaving(false);
}



  };
  // 🔐 ŞİFRE DEĞİŞTİR
  const handleChangePassword = async () => {
    if (passLoading) return;

    if (!currentPassword || !newPassword || !newPassword2) {
alert(TT.fillAllFields);
      return;
    }

    if (newPassword !== newPassword2) {
alert(TT.passwordsNotMatch);
      return;
    }

    if (newPassword.length < 6) {
alert(TT.passwordMin);
      return;
    }

    const token = localStorage.getItem("token");
    if (!token) {
alert(TT.sessionNotFound);
      return;
    }

    setPassLoading(true);

    try {
      const res = await fetch(`${API_BASE}/auth/change-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          currentPassword,
          newPassword,
        }),
      });

      const data = await res.json();

      if (!res.ok) {
        alert(data.error || "Şifre değiştirilemedi");
        return;
      }

alert(TT.passwordUpdated);

      setCurrentPassword("");
      setNewPassword("");
      setNewPassword2("");
      setOpenPass(false);

    } catch (e) {
alert(TT.serverError);
    } finally {
      setPassLoading(false);
    }
  };


  return (
  <div className="w-full min-h-screen bg-[#F7F8FA]">
  <div className="w-full px-3 md:px-6 lg:px-8 py-4">

        {/* Başlık + UI dili */}
        <div className="flex items-center gap-4 mb-8">
          <h1 className="text-3xl md:text-4xl font-extrabold text-gray-900">{TT.settings}</h1>
          <div className="flex items-center gap-3">
            <span className="text-base text-gray-800 font-medium">{TT.uiLanguage}</span>
            <Segmented
              value={uiLang}
              onChange={(code) => {
                setUiLang(code);
                localStorage.setItem("app_lang", code);
                localStorage.setItem("lang", code);
                window.dispatchEvent(new Event("app_lang_change"));
                try {
                  const map = JSON.parse(localStorage.getItem("app_institution_by_lang") || "{}");
                  if (map && typeof map === "object") {
                    localStorage.setItem("app_institution_name", map[code] || map.tr || "");
                    window.dispatchEvent(new Event("app_settings_change"));
                  }
                } catch {}
              }}
            />
          </div>
        </div>

        {/* İçerik dilleri */}
        <div className="mb-8 p-5 bg-white rounded-2xl shadow border border-gray-100">
          <div className="flex flex-col gap-4">
            <div className="text-xl md:text-2xl font-bold text-gray-900">{TT.contentLanguage}</div>
            <div className="flex flex-wrap gap-2">
              {LANGS.map((l) => {
                const active = activeContentLangs.includes(l.code);
                return (
                  <button
                    key={l.code}
                    type="button"
                    onClick={() => toggleActiveLang(l.code)}
                    className={[
                      "px-3 py-1.5 rounded-full text-sm border transition font-medium",
                      active ? "bg-blue-600 text-white border-blue-600" : "bg-white text-blue-700 border-blue-600 hover:bg-blue-50",
                    ].join(" ")}
                  >
                    {l.label}
                  </button>
                );
              })}
            </div>
          </div>
        </div>

        {/* Dil-özel metinler */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="p-5 bg-white rounded-2xl shadow border border-gray-100">
            <div className="mb-4">
              <label className="block text-[19px] font-semibold text-gray-900">{TT.firmName}</label>
              <input
                type="text"
                value={firmaAdiByLang[contentLang]}
                onChange={(e) => setFirmaAdiByLang((p) => ({ ...p, [contentLang]: e.target.value }))}
                className="w-full p-3 border rounded-xl mt-1 text-base text-gray-900"
                placeholder={TT.firmName}
              />
            </div>
            <div>
              <label className="block text-[19px] font-semibold text-gray-900">{TT.slogan}</label>
              <input
                type="text"
                value={sloganByLang[contentLang]}
                onChange={(e) => setSloganByLang((p) => ({ ...p, [contentLang]: e.target.value }))}
                className="w-full p-3 border rounded-xl mt-1 text-base text-gray-900"
                placeholder={TT.slogan}
              />
            </div>
          </div>

          {/* Dil-dışı alanlar */}
          <div className="p-5 bg-white rounded-2xl shadow border border-gray-100">
            <div className="mb-4">
              <label className="block text-[19px] font-semibold text-gray-900">{TT.branch}</label>
              <input type="text" value={subeAdi} onChange={(e) => setSubeAdi(e.target.value)} className="w-full p-3 border rounded-xl mt-1 text-base text-gray-900" />
            </div>

            <div className="mb-4">
              <label className="block text-[19px] font-semibold text-gray-900">{TT.authorizedEditable}</label>
              <input type="text" value={newAuthorized} onChange={(e) => setNewAuthorized(e.target.value)} className="w-full p-3 border rounded-xl mt-1 text-base text-gray-900" placeholder={TT.authorizedEditable} />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
              <div>
                <label className="block text-[19px] font-semibold text-gray-900">{TT.city}</label>
                <input type="text" value={il} onChange={(e) => setIl(e.target.value)} className="w-full p-3 border rounded-xl mt-1 text-base text-gray-900" />
              </div>
              <div>
                <label className="block text-[19px] font-semibold text-gray-900">{TT.district}</label>
                <input type="text" value={ilce} onChange={(e) => setIlce(e.target.value)} className="w-full p-3 border rounded-xl mt-1 text-base text-gray-900" />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-[19px] font-semibold text-gray-900">{TT.phone}</label>
                <input type="tel" value={telefon} onChange={(e) => setTelefon(e.target.value)} className="w-full p-3 border rounded-xl mt-1 text-base text-gray-900" />
              </div>
              <div>
                <label className="block text-[19px] font-semibold text-gray-900">{TT.email}</label>
                <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full p-3 border rounded-xl mt-1 text-base text-gray-900" />
              </div>
            </div>

            <div className="mt-4">
              <label className="block text-[19px] font-semibold text-gray-900">{TT.website}</label>
              <input type="url" value={website} onChange={(e) => setWebsite(e.target.value)} className="w-full p-3 border rounded-xl mt-1 text-base text-gray-900" />
            </div>
          </div>

          {/* Logo alanı — Etkinlikler formatı */}
          <div className="p-5 bg-white rounded-2xl shadow border border-gray-100">
            <label className="block text-[19px] font-semibold text-gray-900 mb-2">{TT.logoUpload}</label>
            <div style={{ display: "grid", gridTemplateColumns: "96px 1fr", gap: 12, alignItems: "center" }}>
              <div>
                {logo ? (
                  <img key={previewUrl} src={previewUrl} alt="Logo" style={{ width: 88, height: 88, objectFit: "cover", borderRadius: 10, border: "1px solid #e5e7eb" }} />
                ) : (
                  <div style={{ width: 88, height: 88, borderRadius: 10, border: "1px dashed #cbd5e1", display: "grid", placeItems: "center", color: "#94a3b8", fontSize: 20 }}>🖼️</div>
                )}
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr auto", gap: 8 }}>
                <input
                  value={logo || ""}
                  onChange={(e) => setLogo(e.target.value)}
                  onBlur={(e) => { setLogo(normalizeUploadUrl(e.target.value)); setLogoVer((n) => n + 1); }}
                  className="w-full p-3 border rounded-xl mt-0 text-base text-gray-900"
                  placeholder="https://... (logo URL)"
                />
                <ResimUpload
                  label={TT.logoUpload}
                  onUpload={(url) => {
                    const fixed = normalizeUploadUrl(url);
                    setLogo(fixed);
                    setLogoVer((n) => n + 1);
                    localStorage.setItem("app_logo_url", fixed);
                    window.dispatchEvent(new Event("app_settings_change"));
                  }}
                  defaultPreview={previewUrl || undefined}
                />
              </div>
            </div>
          </div>
          {/* /Logo alanı */}


{/* ================= EXTRA MENÜ AYARLARI ================= */}
<div className="p-5 bg-white rounded-2xl shadow border border-gray-100">
<h2 className="text-xl font-bold text-gray-900 mb-4">
  🍽️ {TT.menuSettings}
</h2>

{/* ================= RANDEVU SİSTEMİ ================= */}
<div className="p-5 bg-white rounded-2xl shadow border border-gray-100 mt-6">
  <h2 className="text-xl font-bold text-gray-900 mb-4">
    📅 Randevu Sistemi
  </h2>

  <div className="flex items-center justify-between">
    <div>
      <div className="font-semibold text-gray-900">
        Randevu Sistemini Aktif Et
      </div>
      <div className="text-sm text-gray-500">
        Doktor, restoran, hizmet randevuları
      </div>
    </div>

    <input
      type="checkbox"
      checked={enableBooking}
      onChange={(e) => setEnableBooking(e.target.checked)}
      className="w-5 h-5 accent-orange-600"
    />
  </div>
</div>

{/* 🔶 AYIRICI – sadece görsel */}
<hr className="my-8 border-t-2 border-orange-200" />


{/* ================= MUHASEBE / VERGİ / SİGORTA ================= */}
<div className="p-5 bg-white rounded-2xl shadow border border-gray-100 mt-6">
  <h2 className="text-xl font-bold text-gray-900 mb-4">
    🧾 Muhasebe / Vergi / Sigorta
  </h2>

  <div className="flex items-center justify-between">
    <div>
      <div className="font-semibold text-gray-800">
        Muhasebe ve Vergi Süreçlerini Aktif Et
      </div>
      <div className="text-sm text-gray-500">
        Evrak toplama, vergi beyanı ve sigorta işlemleri
      </div>
    </div>

    <input
      type="checkbox"
      checked={enableAccounting}
      onChange={(e) => setEnableAccounting(e.target.checked)}
      className="w-5 h-5 accent-orange-600"
    />
  </div>
</div>

{/* 🔶 AYIRICI – sadece görsel */}
<hr className="my-8 border-t-2 border-orange-200" />

{/* ================= DİJİTAL İMZA SİSTEMİ ================= */}
<div className="p-5 bg-white rounded-2xl shadow border border-gray-100 mt-6">
  <h2 className="text-xl font-bold text-gray-900 mb-4">
    📄 Dijital Evrak & İmza
  </h2>
  <div className="flex items-center justify-between">
    <div>
      <div className="font-semibold text-gray-800">
        Dijital İmza Sistemini Aktif Et
      </div>
      <div className="text-sm text-gray-500">
        PDF evrak gönderimi, mobil imza, imzalı PDF takibi
      </div>
    </div>
    <input
      type="checkbox"
      checked={enableDigitalSignature}
      onChange={(e) => setEnableDigitalSignature(e.target.checked)}
      className="w-5 h-5 accent-orange-600"
    />
  </div>
</div>

{/* 🔶 AYIRICI – sadece görsel */}
<hr className="my-8 border-t-2 border-orange-200" />


{/* ================= 📎 DOSYA & LINK PAYLAŞIMLARI ================= */}
<div className="mt-6 w-full bg-white rounded-2xl shadow border border-gray-200 p-4 md:p-6">

 <h2 className="text-2xl font-bold p-6 border-b">
  📎 {TT.downloadsTitle}
</h2>

 

  {/* ================= EKLE / GÜNCELLE FORMU (EN ALT) ================= */}
  <div className="border-t p-6 bg-gray-50 space-y-3">

    <h3 className="text-lg font-bold">
     {editingDownloadId ? `✏️ ${TT.downloadEdit}` : `➕ ${TT.downloadAdd}`}

    </h3>

<input
  className="w-full p-3 border rounded-xl"
placeholder={TT.title}
  value={downloadDraft.title[contentLang] || ""}
  onChange={e =>
    setDownloadDraft({
      ...downloadDraft,
      title: {
        ...downloadDraft.title,
        [contentLang]: e.target.value
      }
    })
  }
/>


    <textarea
  className="w-full p-3 border rounded-xl"
placeholder={TT.description}
  value={downloadDraft.description[contentLang] || ""}
  onChange={e =>
    setDownloadDraft({
      ...downloadDraft,
      description: {
        ...downloadDraft.description,
        [contentLang]: e.target.value
      }
    })
  }
/>


    <ResimUpload
  label={TT.uploadFile}
  mode="all"
  onUpload={url =>
    setDownloadDraft({
      ...downloadDraft,
      file: normalizeUploadUrl(url)
    })
  }
/>


    {downloadDraft.file && (
      <div className="text-sm text-green-700 break-all">
        📄 {downloadDraft.file}
      </div>
    )}

    <input
      className="w-full p-3 border rounded-xl"
      placeholder="https://..."
      value={downloadDraft.link}
      onChange={e =>
        setDownloadDraft({ ...downloadDraft, link: e.target.value })
      }
    />

    <button
      className="w-full bg-green-600 text-white py-3 rounded-xl font-semibold"
      onClick={() => {
    if (
  !downloadDraft.title.tr &&
  !downloadDraft.title.en &&
  !downloadDraft.title.de &&
  !downloadDraft.file &&
  !downloadDraft.link
) return;


        if (editingDownloadId) {
          // GÜNCELLE
        setDownloads(downloads.map(d =>
  d.id === editingDownloadId
    ? {
        ...d,
        title: {
          ...d.title,
          ...downloadDraft.title
        },
        description: {
          ...d.description,
          ...downloadDraft.description
        },
        file: downloadDraft.file,
        link: downloadDraft.link
      }
    : d
));



        } else {
          // EKLE
          setDownloads([
            ...downloads,
            {
              id: Date.now(),
            title: { ...downloadDraft.title },
description: { ...downloadDraft.description },

              file: downloadDraft.file,
              link: downloadDraft.link
            }
          ]);
        }

        // RESET
      setDownloadDraft({
  title: { tr:"", en:"", de:"" },
  description: { tr:"", en:"", de:"" },
  file: "",
  link: ""
});

        setEditingDownloadId(null);
      }}
    >
{editingDownloadId ? `💾 ${TT.update}` : `➕ ${TT.add}`}
    </button>
  </div>


{/* ================= LİSTE ================= */}
<div className="space-y-4 p-6">

  {downloads.length === 0 && (
    <div className="text-gray-500 text-sm">
{TT.noDownloads}
    </div>
  )}

  {downloads.map((item, index) => (
    <div key={item.id} className="bg-gray-50 border rounded-xl p-4">
      <div className="flex justify-between items-start gap-4">
        <div className="flex-1">
          <div className="font-bold text-lg">
{item.title?.[contentLang] || item.title?.tr
 || TT.unnamed}
          </div>

          {item.description?.[contentLang] && (
            <div className="text-sm text-gray-600 mt-1">
              {item.description[contentLang]}
            </div>
          )}

          {item.file && (
            <a
              href={item.file}
              target="_blank"
              rel="noreferrer"
              className="block mt-2 text-green-700 text-sm break-all"
            >
              📄 {TT.file}
            </a>
          )}

          {item.link && (
            <a
              href={item.link}
              target="_blank"
              rel="noreferrer"
              className="block mt-1 text-blue-700 text-sm break-all"
            >
              🔗{TT.link}
            </a>
          )}
        </div>

        <div className="flex gap-3">
          <button
            className="text-orange-600 font-semibold"
            onClick={() => {
              setEditingDownloadId(item.id);
             setDownloadDraft({
  title: item.title || { tr:"", en:"", de:"" },
  description: item.description || { tr:"", en:"", de:"" },
  file: item.file || "",
  link: item.link || ""
});

            }}
          >
            ✏️ {TT.edit}
          </button>

          <button
            className="text-red-600 font-semibold"
            onClick={() =>
              setDownloads(downloads.filter((_, i) => i !== index))
            }
          >
            🗑{TT.delete}
          </button>
        </div>
      </div>
    </div>
  ))}
</div>

</div>




{/* ================= PAZAR YERİ GÖRÜNÜRLÜK ================= */}
<div className="p-5 bg-white rounded-2xl shadow border border-gray-100 mt-6">
  <h2 className="text-xl font-bold text-gray-900 mb-4">
    🏬 {TT.marketplaceVisibility}
  </h2>

  <div className="space-y-4">
    <div className="flex items-center gap-4">
      <input
        type="radio"
        id="marketplace-all"
        name="marketplaceVisibility"
        value="all"
        checked={marketplaceVisibility === "all"}
        onChange={(e) => setMarketplaceVisibility(e.target.value)}
        className="w-5 h-5 accent-orange-600"
      />
      <label htmlFor="marketplace-all" className="text-gray-800">
        <span className="font-semibold">{TT.marketplaceAll}</span>
        <p className="text-sm text-gray-500">{TT.marketplaceVisibilityDesc} - {TT.marketplaceAll}</p>
      </label>
    </div>

    <div className="flex items-center gap-4">
      <input
        type="radio"
        id="marketplace-sector"
        name="marketplaceVisibility"
        value="sector"
        checked={marketplaceVisibility === "sector"}
        onChange={(e) => setMarketplaceVisibility(e.target.value)}
        className="w-5 h-5 accent-orange-600"
      />
      <label htmlFor="marketplace-sector" className="text-gray-800">
        <span className="font-semibold">{TT.marketplaceOwnSector}</span>
        <p className="text-sm text-gray-500">Sadece kendi sektörüm dışındaki kurumlar görünsün</p>
      </label>
    </div>

    <div className="flex items-center gap-4">
      <input
        type="radio"
        id="marketplace-none"
        name="marketplaceVisibility"
        value="none"
        checked={marketplaceVisibility === "none"}
        onChange={(e) => setMarketplaceVisibility(e.target.value)}
        className="w-5 h-5 accent-orange-600"
      />
      <label htmlFor="marketplace-none" className="text-gray-800">
        <span className="font-semibold">{TT.marketplaceNone}</span>
        <p className="text-sm text-gray-500">{TT.marketplaceVisibilityDesc} - {TT.marketplaceNone}</p>
      </label>
    </div>
  </div>
</div>






{/* ================= MENÜ / HİZMET AYARLARI ================= */}
<div className="p-5 bg-white rounded-2xl shadow border border-gray-100">

  {/* Menü aktif mi */}
  <div className="flex items-center justify-between mb-4">
    <div>
      <div className="font-semibold text-gray-900">
        {TT.menuEnableTitle}
      </div>
      <div className="text-sm text-gray-500">
        {TT.menuEnableDesc}
      </div>
    </div>

    <input
      type="checkbox"
      checked={enableMenu}
      onChange={(e) => setEnableMenu(e.target.checked)}
      className="w-5 h-5 accent-orange-600"
    />
  </div>

  {/* Alerji bilgileri */}
  {enableMenu && (
    <div className="flex items-center justify-between">
      <div>
        <div className="font-semibold text-gray-900">
          {TT.allergenTitle}
        </div>
        <div className="text-sm text-gray-500">
          {TT.allergenDesc}
        </div>
      </div>

      <input
        type="checkbox"
        checked={enableAllergens}
        onChange={(e) => setEnableAllergens(e.target.checked)}
        className="w-5 h-5 accent-orange-600"
      />
    </div>
  )}
</div>

  

{/* 🌍 MENÜ YAYIN DİLİ (WEB'DE HANGİ DİLLER GÖRÜNECEK) */}
{enableMenu && (
  <div className="mt-4 pt-4 border-t">
   
<div className="font-semibold text-gray-900">
  {TT.menuLangTitle}
</div>
<div className="text-sm text-gray-500 mb-3">
  {TT.menuLangDesc}
</div>


    <div className="flex flex-wrap gap-2">
      {LANGS.map((l) => {
        const active = menuLangs.includes(l.code);
        return (
          <button
            key={l.code}
            type="button"
            onClick={() => toggleMenuLang(l.code)}
            className={[
              "px-3 py-1.5 rounded-full text-sm border transition font-medium",
              active
                ? "bg-orange-600 text-white border-orange-600"
                : "bg-white text-gray-700 border-gray-300 hover:bg-gray-100",
            ].join(" ")}
          >
            {l.label}
          </button>
        );
      })}
    </div>
  </div>
)}
</div>



{/* ================= MENÜ YÖNETİMİ ================= */}
<>
{enableMenu && (
  <div className="mt-4 w-full bg-white rounded-2xl shadow border border-gray-200 p-4 md:p-6">

   <h2 className="text-2xl font-bold p-6 border-b">
  {TT.menuManager}
</h2>


{/* ANA KATEGORİ SEÇ */}
<div className="p-6 border-b flex flex-col md:flex-row gap-3">
  <select
    className="p-3 border rounded-xl w-full md:w-1/2"
    onChange={(e) => {
      const selected = e.target.value;
      if (!selected) return;

      // Aynı kategori tekrar eklenmesin
if (menuCategories.find(c => c.key === selected)) return;

   setMenuCategories(prev => [
  ...prev,
  {
    id: Date.now(),
    key: selected,     // ✅ SADECE KEY
    items: [],
    draft: {
      name: "",
      description: "",
      price: "",
      currency: "TRY",
      image: "",
      allergens: []
    }
  }
]);

    }}
  >
<option value="">{TT.categorySelect}</option>
   {Object.entries(CATEGORY_DICT).map(([key, labels]) => (
  <option key={key} value={key}>
    {labels[uiLang] || labels.tr}
  </option>
))}

  </select>
</div>


    {/* ================= KATEGORİLER ================= */}
   {menuCategories.map((cat, cIndex) => (
  <div
    key={cat.id}
    className="p-6 border-b bg-gray-50"
    draggable
    onDragStart={(e) => {
      e.dataTransfer.setData("fromIndex", cIndex);
    }}
    onDragOver={(e) => e.preventDefault()}
    onDrop={(e) => {
      const fromIndex = Number(e.dataTransfer.getData("fromIndex"));
      moveCategory(fromIndex, cIndex);
    }}
  >


       {/* KATEGORİ BAŞLIK */}
<div
  className="flex items-center justify-between mb-4 gap-3 cursor-pointer"
  onClick={() =>
    setOpenCategoryId(openCategoryId === cat.id ? null : cat.id)
  }
>
  

<div className="flex items-center gap-3 flex-1">
  <span className="text-xl">
    {openCategoryId === cat.id ? "▼" : "▶"}
  </span>

  {/* 👇 SÜRÜKLEME TUTMA İKONU */}
  <span
    className="cursor-move text-gray-400 hover:text-gray-700"
    title="Sürükleyerek sırala"
  >
    ☰
  </span>

  <div className="text-xl font-bold">
    <h3>
      {CATEGORY_DICT[cat.key]
        ? CATEGORY_DICT[cat.key][uiLang] || CATEGORY_DICT[cat.key].tr
        : cat.name}
    </h3>
    <span className="ml-2 text-sm text-gray-500">
      ({cat.items.length} {TT.productCount})
    </span>
  </div>
</div>


  {/* ❌ DÜZENLE KALDIRILDI – SADECE SİL */}
  <div className="flex gap-3" onClick={(e) => e.stopPropagation()}>
    <button
      className="text-red-600 font-semibold"
      onClick={() =>
        setMenuCategories(menuCategories.filter((_, i) => i !== cIndex))
      }
    >
      {TT.delete}
    </button>
  </div>
</div>



        {/* AKORDİYON */}
        {openCategoryId === cat.id && (
          <>
            {/* ÜRÜN EKLEME FORMU */}
            <div className="bg-white p-4 rounded-xl border mb-6 space-y-3">

              <ResimUpload
  key={cat.id + "-draft"}   // ✅ SABİT KEY

                label={TT.productImage}
                onUpload={(url) => {
                  const copy = [...menuCategories];
                  copy[cIndex].draft.image = url;
                  setMenuCategories(copy);
                }}
              />

              <input
placeholder={TT.productName}
                className="w-full p-3 border rounded-xl"
              
  value={cat.draft.name}
                onChange={(e) => {
                  const copy = [...menuCategories];
                  copy[cIndex].draft.name = e.target.value;
                  setMenuCategories(copy);
                }}
              />

              <textarea
placeholder={TT.productDesc}
                className="w-full p-3 border rounded-xl"
                value={cat.draft.description}
                onChange={(e) => {
                  const copy = [...menuCategories];
                  copy[cIndex].draft.description = e.target.value;
                  setMenuCategories(copy);
                }}
              />



              <div className="flex gap-3">
                <input
                  type="number"
placeholder={TT.price}
                  className="flex-1 p-3 border rounded-xl"
                  value={cat.draft.price}
                  onChange={(e) => {
                    const copy = [...menuCategories];
                    copy[cIndex].draft.price = e.target.value;
                    setMenuCategories(copy);
                  }}
                />
                <select
                  className="p-3 border rounded-xl"
                  value={cat.draft.currency}
                  onChange={(e) => {
                    const copy = [...menuCategories];
                    copy[cIndex].draft.currency = e.target.value;
                    setMenuCategories(copy);
                  }}
                >
                 <option value="TRY">{TT.currencyTRY}</option>
<option value="USD">{TT.currencyUSD}</option>
<option value="EUR">{TT.currencyEUR}</option>
<option value="CHF">{TT.currencyCHF}</option>

                </select>
              </div>

{/* === ÜRÜN LİSTESİ === */}
{cat.items.map((item, iIndex) => (
  <div
    key={item.id}
    className="bg-white p-4 rounded-xl border mb-3 flex gap-4"
  >
    <div className="w-20 h-20 bg-gray-100 rounded-lg overflow-hidden">
      {item.image ? (
        <img src={item.image} className="w-full h-full object-cover" />
      ) : (
        <div className="w-full h-full flex items-center justify-center text-gray-400">🖼️</div>
      )}
    </div>

    <div className="flex-1">
      <div className="font-bold">{item.name}</div>
      <div className="text-sm text-gray-600">{item.description}</div>
      <div className="mt-1 font-semibold">
        {item.price} {item.currency}

{enableAllergens && item.allergens?.length > 0 && (
  <div className="flex flex-wrap gap-2 mt-2">
    {item.allergens.map(a => (
      <span
        key={a}
        className="px-2 py-0.5 text-xs rounded-full bg-orange-100 text-orange-700 border border-orange-300"
      >
        {a}
      </span>
    ))}
  </div>


)}

{/* ⭐ TREND ÜRÜN CHECKBOX */}
<label className="flex items-center gap-2 mt-2 text-sm text-gray-700">
  <input
    type="checkbox"
    checked={item.is_trend === true}
    onChange={() => {
      const copy = [...menuCategories];
      copy[cIndex].items[iIndex].is_trend = !item.is_trend;
      setMenuCategories(copy);
    }}
    className="accent-orange-600"
  />
{TT.trendProduct}
</label> 
      </div>



      <div className="flex gap-4 mt-2">
        <button
          className="text-orange-600 text-sm font-semibold"
          onClick={() => {
            const copy = [...menuCategories];
            copy[cIndex].draft = { ...item };
            copy[cIndex].items.splice(iIndex, 1);
            setMenuCategories(copy);
          }}
        >
          {TT.edit}

        </button>

        <button
          className="text-red-600 text-sm font-semibold"
          onClick={() => {
            const copy = [...menuCategories];
            copy[cIndex].items.splice(iIndex, 1);
            setMenuCategories(copy);
          }}
        >
           {TT.delete}
        </button>
      </div>
    </div>
  </div>
))}




              {enableAllergens && (


<div className="flex flex-wrap gap-2">
  {ALLERGEN_KEYS.map(key => (
    <button
      key={key}
      type="button"
      className={`px-3 py-1 rounded-full text-sm border ${
        cat.draft.allergens.includes(key)
          ? "bg-orange-600 text-white border-orange-600"
          : "bg-white text-gray-700 border-gray-300"
      }`}
      onClick={() => {
        const copy = [...menuCategories];
        const list = copy[cIndex].draft.allergens;
        copy[cIndex].draft.allergens = list.includes(key)
          ? list.filter(x => x !== key)
          : [...list, key];
        setMenuCategories(copy);
      }}
    >
      {TT.allergens[key]}
    </button>
  ))}
</div>


              )}

              <button
                className="w-full bg-green-600 text-white py-3 rounded-xl font-semibold"
                onClick={() => {
                  if (!cat.draft.name) return;
                  const copy = [...menuCategories];
                  copy[cIndex].items.push({
                    id: Date.now(),
                    ...copy[cIndex].draft
                  });
                  copy[cIndex].draft = {
                    name: "",
                    description: "",
                    price: "",
                    currency: "TRY",
                    image: "",
                    allergens: []


                  };
                  setMenuCategories(copy);
                }}
              >
                 {TT.addProduct}

              </button>
            </div>
          </>
        )}
      </div>
    ))}
  </div>
)}




{/* ================= 🔐 ŞİFRE DEĞİŞTİR ================= */}
<div className="mt-10 bg-white rounded-2xl shadow border border-gray-200 overflow-hidden">
  <button
    type="button"
    onClick={() => setOpenPass(!openPass)}
    className="w-full flex items-center justify-between px-6 py-4 hover:bg-gray-50"
  >
    <div>
      <div className="text-lg font-extrabold text-gray-900">
        {TT.passwordChangeTitle}
      </div>
      <div className="text-sm text-gray-500">
        {TT.passwordChangeDesc}
      </div>
    </div>
    <div className="text-2xl text-gray-500">
      {openPass ? "−" : "+"}
    </div>
  </button>

  {openPass && (
    <div className="px-6 pb-6 pt-2 border-t bg-gray-50 space-y-4">
      <input
        type="password"
        placeholder={TT.currentPassword}
        value={currentPassword}
        onChange={(e) => setCurrentPassword(e.target.value)}
        className="w-full p-3 border rounded-xl"
      />

      <input
        type="password"
        placeholder={TT.newPassword}
        value={newPassword}
        onChange={(e) => setNewPassword(e.target.value)}
        className="w-full p-3 border rounded-xl"
      />

      <input
        type="password"
        placeholder={TT.newPasswordRepeat}
        value={newPassword2}
        onChange={(e) => setNewPassword2(e.target.value)}
        className="w-full p-3 border rounded-xl"
      />

      <button
        onClick={handleChangePassword}
        disabled={passLoading}
        className={`w-full py-3 rounded-xl font-semibold text-white ${
          passLoading ? "bg-gray-400" : "bg-red-600 hover:bg-red-700"
        }`}
      >
        {passLoading ? "⏳" : "🔐"} {TT.updatePassword}
      </button>
    </div>
  )}
</div>

{/* KAYDET BUTONU */}



<div className="mt-10">
  <button
    onClick={handleSave}
    disabled={isSaving}
    className={[
      "px-6 py-3 rounded-2xl text-lg font-semibold shadow",
      isSaving
        ? "bg-gray-400 text-white cursor-not-allowed"
        : "bg-orange-600 hover:bg-orange-700 text-white"
    ].join(" ")}
  >
    {isSaving ? "⏳" : "💾"} {TT.save}
  </button>
</div>
</>
</div>
 </div>
</div>
  );
}
